import { useMemo } from 'react';
import { useGetAdAccountsByBusinessUnitQuery } from 'services/api/relifMeta.api';

interface UseCampaignDynamicOptionsArgs {
  businessUnitId: number | null;
}

export interface MetaAccountOption {
  id: string;
  name: string;
  currency?: string;
}

interface UseCampaignDynamicOptionsResult {
  metaAccounts: MetaAccountOption[];
  isLoading: boolean;
  hasMetaAccounts: boolean;
}

/**
 * Resolves the list of Meta Ad Accounts for the selected business unit. Feeds the
 * AdAccountSidebar where the user toggles which accounts' campaigns to display.
 */
export const useCampaignDynamicOptions = ({
  businessUnitId,
}: UseCampaignDynamicOptionsArgs): UseCampaignDynamicOptionsResult => {
  const { data, isFetching } = useGetAdAccountsByBusinessUnitQuery(businessUnitId as number, {
    skip: !businessUnitId,
  });

  const metaAccounts = useMemo<MetaAccountOption[]>(() => {
    if (!data?.adAccounts) return [];
    return data.adAccounts.map((account) => ({
      id: account.metaAdAccountId,
      name: account.name,
      currency: account.currency,
    }));
  }, [data]);

  return {
    metaAccounts,
    isLoading: isFetching,
    hasMetaAccounts: metaAccounts.length > 0,
  };
};
